import { combineReducers } from 'redux'

import list from './list/slice'

const specificReducer = combineReducers({
  list,
})

export default specificReducer
